module.exports = __webpack_public_path__ + "img/xero-2x.4445ab2d.png";